import { DISPLAY_LANG } from "../../config";
import axios from "../../axios";

export const onlyLatinMessage = {
    "en": "Fill in Latin letters only",
    "ru": "Вставляйте только латинские буквы.",
    "am": "Լրացնել միայն լատինատառ",
};

export const getRegisterData = async () => {
    const res = await axios.get(`userspagesdata/register-page?lang=${DISPLAY_LANG}`)
    return res.data[0];
};

export const getRegisterEmailSubmitData = async () => {
    const res = await axios.get(`userspagesdata/register_email_submit?lang=${DISPLAY_LANG}`)
    return res.data;
};

export const registerEmail = async (email) => {
    const res = await axios.post('users/auth/send_email', { email, code: null });
    return res.data;
};

export const registerEmailCode = async (email, code) => {
    const res = await axios.post('users/auth/send_email', { email, code });
    return res.data;
};

export const registerUser = async (body) => {
    /**
     * @description  
     * delete em anum, vorovhetev BAZAI mej chka confirm_password syun@,
     * */
    delete body.confirm_password;

    const res = await axios.post('users/auth/register', body);
    return res.data;
};